export default __webpack_public_path__ + "static/media/19.fd94cb9a.jpg";